import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import * as moment from 'moment';
import { AmazingTimePickerService } from 'amazing-time-picker';

@Component({
  selector: 'app-sandbox-dialog',
  templateUrl: './sandbox-dialog.component.html',
  styleUrls: ['./sandbox-dialog.component.css']
})
export class SandboxDialogComponent implements OnInit {


  days = [
    ['Sunday', null,"2018-01-07 "],
    ['Monday', null,"2018-01-08 "],
    ['Tuesday', null,"2018-01-09 "],
    ['Wednesday', null,"2018-01-10 "],
    ['Thursday', null, "2018-01-11 "],
    ['Friday', null, "2018-01-12 "],
    ['Saturday', null,"2018-01-13 "]
  ];

  constructor(private atp: AmazingTimePickerService,public dialogRef: MatDialogRef<SandboxDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      this.dialogRef.disableClose = true;
    }

  ngOnInit() {

  }

  getDisplayTime(time) {
    if (time == null) {
      return 'No Time Selected'
    } else {
      return moment('2018-01-01 ' + time + ':00').format('hh:mm A')
    }
  }

  clearTime(day) {
    this.days.find(x => x[0] == day)[1] = null;
  }

  openPicker(): Promise<any> {
    return new Promise((resolve, reject) => {
      const amazingTimePicker = this.atp.open();
      amazingTimePicker.afterClose().subscribe(time => {
        resolve(time);
      });
    })
  }

  open(day) {
    this.openPicker().then(time => {
      var tuple = this.days.find(x => x[0] == day);
      tuple[1] = time;

    })
  }

  cancel(){
    this.dialogRef.close({schedule:null});
  }
  
  done(){

    var valid = false;


    this.days.forEach(d =>{
      if(d[1] != null){
        valid = true;
        d[1] = d[2] + d[1]+":00";
      }
    })
    if(valid){
      console.log(this.days);
      this.dialogRef.close({schedule:this.days});
    }else{
      alert("Please pick a time for at least one day");
    }

  }


}



// WEBPACK FOOTER //
// ./src/app/admin-dashboard/optimizer/sandbox-dialog/sandbox-dialog.component.ts